import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CreateAccountAuthComponent } from './components/create-account-auth/create-account-auth.component'
import { CreateAccountPanelShellComponent } from './components/create-account-panel-shell/create-account-panel-shell.component'
import { CreateAccountShellComponent } from './components/create-account-shell/create-account-shell.component'

const routes: Routes = [
  {
    path: 'create_account',
    component: CreateAccountShellComponent,
    children: [
      {
        path: '',
        component: CreateAccountPanelShellComponent,
        children: [{ path: '', component: CreateAccountAuthComponent }],
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateAccountRoutingModule {}
